import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2
      }
    );

    const currentElement = sectionRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-20 bg-white opacity-0 transition-opacity duration-1000 ease-out" 
      id="hakkimizda"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start mb-20">
          {/* Left Column */}
          <div className="flex items-center">
            <div className="w-4 h-4 rounded-full bg-primaryBlue flex-shrink-0"></div>
            <h2 className="text-md font-medium text-black ltr:ml-4 rtl:mr-4">{t('about.values_title')}</h2>
          </div>
          
          {/* Right Column */}
          <div className="pb-8 border-b border-gray-200">
            <p className="text-lg text-gray-600 font-medium">
              {t('about.description1')}
            </p>
            <p className="text-lg text-gray-600 mt-8 font-medium">
              {t('about.description2')}
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div>
            <img 
              src="/images/corp.png" 
              alt="Orbitras" 
              className="w-[400px] h-[300px] object-cover rounded-[30px] shadow-lg"
            />
          </div>

          {/* Right Column - Feature Stats */}
          <div className="flex space-x-8">
            {/* Reliability Feature */}
            <div className="flex-1">
              <div className="w-16 h-16 rounded-full bg-slate-900 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('about.features.reliability.title')}</h3>
              <p className="text-gray-600 font-medium">{t('about.features.reliability.description')}</p>
            </div>

            {/* Quality Feature */}
            <div className="flex-1">
              <div className="w-16 h-16 rounded-full bg-slate-900 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('about.features.quality.title')}</h3>
              <p className="text-gray-600 font-medium">{t('about.features.quality.description')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs; 